import axios from "axios";

// Deliberately separate from services/api.js and its "token" key -
// an admin session and a regular user session need to be able to
// coexist in the same browser without clobbering each other.
const adminApi = axios.create({
    baseURL: process.env.REACT_APP_API_URL + "/api"
});

adminApi.interceptors.request.use(config => {

    const token = localStorage.getItem("adminToken");

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;

});

export default adminApi;
